<template>
  <strong v-if="'5' == discountRateId" class="parts-price-status-free">
    (今だけ無料！)
  </strong>
  <strong
    v-if="'zero' === qtyLabel || 'empty' === qtyLabel"
    class="parts-price-status-qtyzero"
  >
    ※入荷待ち
  </strong>
  <strong
    v-if="'border' === qtyLabel || 'warning' === qtyLabel"
    class="parts-price-status-qtyborder"
  >
    ※在庫わずか
  </strong>
</template>

<script>
export default {
  name: "PartsPriceStatus",

  props: {
    discountRateId: {
      type: String,
    },
    qtyLabel: {
      type: String,
    },
  },
};
</script>

<style scoped lang="stylus">

.parts-price-status-free,
.parts-price-status-qtborder
	color: #ee777b;

.parts-price-status-qtyzero
	color: #111;
</style>
